"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryTokens = void 0;

var _common = require("./../common");

var _utils = require("./../common/utils");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryTokens = new _CrudBuilder.CrudBuilder(class BasisTheoryTokens extends _service.BasisTheoryService {
  constructor(options) {
    const _options = options; // eslint-disable-next-line unicorn/prefer-spread

    _options.transformRequest = [].concat(_utils.transformTokenRequestSnakeCase, options.transformRequest || []); // eslint-disable-next-line unicorn/prefer-spread

    _options.transformResponse = [].concat(_utils.transformTokenResponseCamelCase, options.transformResponse || []);
    super(_options);
  }

  retrieve(id, options = {} // avoid casting when accessing token data props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) {
    const url = `/${id}`;
    return this.client.get(url, (0, _common.createRequestConfig)(options)).then(_utils.dataExtractor);
  }

  update(id, model, options = {}) {
    const url = `/${id}`;
    const config = (0, _common.createRequestConfig)(options);
    return this.client.patch(url, model, { ...config,
      headers: { ...((config === null || config === void 0 ? void 0 : config.headers) || {}),
        [_common.CONTENT_TYPE_HEADER]: _common.MERGE_CONTENT_TYPE
      }
    }).then(_utils.dataExtractor);
  }

  search(searchRequest, options) {
    return this.client.post('/search', searchRequest, (0, _common.createRequestConfig)(options)).then(_utils.dataExtractor);
  }

}).create().delete().list().build();
exports.BasisTheoryTokens = BasisTheoryTokens;